<div class="form-group">
    <select class="form-control" [(ngModel)]="walletId" name="walletId" (change)="setCurrentWallet(walletId)">
        <option [value]="''" disabled> Select</option>
        <option *ngFor="let wallet of cWallets" [value]="wallet?._id">
            {{ wallet?.organizationName || wallet?.userName }}
        </option>
    </select>
</div>